import type { Locale } from '@/types/regionTypes';

import type { SearchHit, StoreHit } from '@/integrations/algolia/types';

import { getTranslatedStoreValue } from '../StoresList/utils';

export function isSearchHit(hit: SearchHit): hit is SearchHit {
  return (hit as SearchHit).name !== undefined;
}

export const isStoreHit = (hit: unknown): hit is StoreHit => {
  return (
    typeof hit === 'object' &&
    hit !== null &&
    'appointments' in hit &&
    'city' in hit
  );
};

export function getHitName(hit: SearchHit, locale: Locale): string | undefined {
  let hitName;

  if (isStoreHit(hit)) {
    hitName =
      getTranslatedStoreValue(hit, 'name', locale.slug) ||
      getTranslatedStoreValue(hit, 'city', locale.slug);
  } else if (isSearchHit(hit)) {
    if (typeof hit.name === 'object' && hit.name !== null) {
      hitName = hit.name[locale.code.toUpperCase()] as string;
    } else if (typeof hit.name === 'string') {
      hitName = hit.name;
    }
  }
  return hitName;
}

export const getGroupLabel = (groupKey: string): string => {
  switch (groupKey.toUpperCase()) {
    case 'WATCH':
      return 'Watches';
    case 'STRAP':
      return 'Straps';
    case 'EYEWEAR':
      return 'Sunglasses';
    case 'OFFICIAL_RETAILER':
      return 'Official Retailers';
    case 'BOUTIQUE':
      return 'Boutiques';
    case 'SERVICE_CENTER':
      return 'Service Centers';
    case 'OUTLETS':
      return 'Outlets';
    default:
      return 'Others';
  }
};

export function getGroupKey(hit: SearchHit): string {
  if ('product_type' in hit) {
    return hit.product_type;
  } else if ('type' in hit) {
    return hit.type;
  }
  return 'OTHER';
}
